var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[(_vm.props.loading)?_c('div',{staticClass:"d-flex justify-content-center"},[_c('span',{staticClass:"spinner-border"})]):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }